export enum WppInegibleReason {
  NO = "NO",
  SENT = "SENT",
  QUARANTINE = "QUARANTINE",
  BLOCKLIST = "BLOCKLIST",
  ENGAGEMENT = "ENGAGEMENT",
  RESPONSE = "RESPONSE",
}

